import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { TvCommercialGridComponent } from '@adgate/modules/tv/components/tv-commercial-grid-component/tv-commercial-grid-component';
import { Tab, TabAccessorInterface } from '@adgate/common/interfaces/tab-accessor.interface';
import { CommercialFilter } from '@adgate/modules/tv/types/commercial-filter.type';
import { AuthenticationService } from '@adgate/common/services/authentication-service';
import { User } from '@adgate/modules/admin/types/user.type';
import { Status } from '@adgate/common/types/status.type';
import { QuickSearch } from '@adgate/common/interfaces/quick-search.interface';
import { Export } from '@adgate/common/interfaces/export.interface';
import { Filter } from '@adgate/common/interfaces/filter.interface';

@Component({
  selector: 'app-tv-main-component',
  imports: [
    TvCommercialGridComponent,
  ],
  templateUrl: './tv-main-component.html',
  styleUrl: './tv-main-component.scss',
})
export class TvMainComponent extends TabAccessorInterface implements OnInit, QuickSearch, Export, Filter
{
  @ViewChild('tabPending') tabPendingComponent?: TvCommercialGridComponent;
  @ViewChild('tabHistory') tabHistoryComponent?: TvCommercialGridComponent;

  public TAB_PENDINGREJECTED: number    = 0;
  public TAB_HISTORY: number            = 1;

  private authService:AuthenticationService = inject(AuthenticationService);

  pendingRejectedFilter!: CommercialFilter;
  latestFilter!: CommercialFilter;

  constructor()
  {
    super();

    let userAttributes = this.authService.getUserAttributes();

    this.pendingRejectedFilter = new CommercialFilter();
    this.pendingRejectedFilter.status = [{id: Status.TV_CREATED, description:''}, {id: Status.TV_REJECTED, description: ''}, {id: Status.TV_RELOAD, description: ''}, {id: Status.TV_SPECERROR, description:''}];

    this.latestFilter = new CommercialFilter();
    this.latestFilter.createdTo = Date.now() + (1 * 24 * 60 * 60 * 1000);;
    this.latestFilter.createdFrom = Date.now() - (7 * 24 * 60 * 60 * 1000);

    if (userAttributes.type == User.TYPE_OFFICE) {
      this.pendingRejectedFilter.office = [userAttributes.office];
      this.latestFilter.office = [userAttributes.office];
    } 
    
    if (userAttributes.type == User.TYPE_AGENCY) {
      this.pendingRejectedFilter.agency = [userAttributes.agency];
      this.latestFilter.agency = [userAttributes.agency];
    }

    this.setActiveTab(this.TAB_PENDINGREJECTED);
  }

  ngOnInit(): void 
  {

  }

  override getTabs(): Tab[] 
  {
    return [
      {tabNum: 0, tabDescription: 'Pending/Rejected', show: true},
      {tabNum: 1, tabDescription: 'History', show: true}
    ];
  }

  onRefresh()
  {
    const activeTabComponent = this.getActiveTabComponent();
    activeTabComponent.onRefresh();
  }

  showFilters(): boolean 
  {
    try {
      const activeTabComponent = this.getActiveTabComponent();
      return activeTabComponent?.showFilters() || false;
    } catch {
      return false;
    }        
  }

  onFilter()
  {
    const activeTabComponent = this.getActiveTabComponent();
    activeTabComponent.onFilter();
  }

  onExport()
  {
    const activeTabComponent = this.getActiveTabComponent();
    activeTabComponent.onExport();
  }

  getQuickSearchPlaceholder(): string 
  {
    try {
      const activeTabComponent = this.getActiveTabComponent();
      return activeTabComponent?.getQuickSearchPlaceholder() || '';
    } catch {
      return '';
    }    
  }

  onQuickSearch(filter: string | null): void 
  {
    const activeTabComponent = this.getActiveTabComponent();
    activeTabComponent.onQuickSearch(filter);
  }

  getActiveTabComponent(): TvCommercialGridComponent 
  {
    switch (this.getActiveTab()) {
      case this.TAB_PENDINGREJECTED:
        return this.tabPendingComponent!;
      case this.TAB_HISTORY:
        return this.tabHistoryComponent!;
      default:
        throw new Error('Unknown active tab');
    }
  }
}
